import { render, staticRenderFns } from "./FactoryDraft.vue?vue&type=template&id=4d0c8444"
import script from "./FactoryDraft.vue?vue&type=script&lang=js"
export * from "./FactoryDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports